import React from "react";
import "./Careers.css"; // CSS extracted from your inline styles

function Careers() {
  return (
    <section id="careers" className="careers-section py-5">
      <div className="container">
        <h2 className="text-center mb-4 fw-bold text-primary">
          Careers at PTC
        </h2>
        <p className="text-center mb-5 text-muted">
          Be part of our growing team and contribute to world-class industrial
          automation solutions.
        </p>

        <div className="row g-4">
          {/* Job Card 1 */}
          <div className="col-md-4">
            <div className="career-card">
              <h4 className="job-title">Sales Engineer</h4>
              <p className="job-profile">
                <strong>Profile:</strong> Business Development & Client Relations
              </p>
              <p className="job-details">
                <strong>Details:</strong> Responsible for identifying new
                business opportunities, handling client queries, and promoting
                our industrial automation products.
              </p>
              <p className="experience">
                <strong>Experience:</strong> 1-3 years in technical sales
              </p>
              <button className="btn btn-primary w-100">Apply Now</button>
            </div>
          </div>

          {/* Job Card 2 */}
          <div className="col-md-4">
            <div className="career-card">
              <h4 className="job-title">Design Engineer</h4>
              <p className="job-profile">
                <strong>Profile:</strong> Product Design & CAD Development
              </p>
              <p className="job-details">
                <strong>Details:</strong> Work on innovative product designs,
                prepare 2D/3D models, and collaborate with R&D for new solutions.
              </p>
              <p className="experience">
                <strong>Experience:</strong> 2-4 years with AutoCAD/SolidWorks
              </p>
              <button className="btn btn-primary w-100">Apply Now</button>
            </div>
          </div>

          {/* Job Card 3 */}
          <div className="col-md-4">
            <div className="career-card">
              <h4 className="job-title">Service Engineer</h4>
              <p className="job-profile">
                <strong>Profile:</strong> Field Support & Troubleshooting
              </p>
              <p className="job-details">
                <strong>Details:</strong> Provide installation, calibration, and
                after-sales service for automation systems at client sites.
              </p>
              <p className="experience">
                <strong>Experience:</strong> 1-2 years in
                instrumentation/electrical service
              </p>
              <button className="btn btn-primary w-100">Apply Now</button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Careers;
